import { render, staticRenderFns } from "./withdrawBig.vue?vue&type=template&id=cbeaca14&scoped=true"
import script from "./withdrawBig.vue?vue&type=script&lang=js"
export * from "./withdrawBig.vue?vue&type=script&lang=js"
import style0 from "./withdrawBig.vue?vue&type=style&index=0&id=cbeaca14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbeaca14",
  null
  
)

export default component.exports